import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { useLanguage } from '../contexts/LanguageContext';

const DifficultySelection = ({ onSelectDifficulty, onBack }) => {
  const { t } = useLanguage();

  return (
    <div className="difficulty-selection">
      <button className="back-button" onClick={onBack}>{t('back')}</button>
      <h2>{t('chooseDifficultyTitle')}</h2>
      <div className="difficulty-buttons">
        <div className="difficulty-btn easy" onClick={() => onSelectDifficulty('easy')}>
          <div className="difficulty-icon">
            <FontAwesomeIcon icon={faEye} />
          </div>
          <h3>{t('easyMode')}</h3>
          <p>{t('easyDescriptionPlate')}</p>
        </div>
        <div className="difficulty-btn hard" onClick={() => onSelectDifficulty('hard')}>
          <div className="difficulty-icon">
            <FontAwesomeIcon icon={faEyeSlash} />
          </div>
          <h3>{t('hardMode')}</h3>
          <p>{t('hardDescriptionPlate')}</p>
        </div>
      </div>
    </div>
  );
};

export default DifficultySelection;